"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("./SegmentedControl.css");
var _SegmentedControlWithoutStyles = _interopRequireDefault(require("./SegmentedControlWithoutStyles"));
var _default = _SegmentedControlWithoutStyles["default"];
exports["default"] = _default;